const getters = {
    sidebar: state => state.app.sidebar,
    device: state => state.app.device,
    enum: state => state.app.enum,
    token: state => state.user.token,
    name: state => state.user.name,
    currentUser: state => state.user.currentUser,
    currentMenu: state => state.user.currentMenu,
    mobileNo: state => state.user.mobileNo,
    routePermission: state => state.permission.routers,
    total: state => state.permission.total,
    //
    province: state => state.enmus.province,
    city: state => state.enmus.city,
    brand: state => state.enmus.brand,
    queryBrand: state => state.enmus.queryBrand,
    subCompany: state => state.enmus.subCompany,
    pharmacy: state => state.enmus.pharmacy,
    manufacturers: state => state.enmus.manufacturers
}

export default getters
